export const ds_RichTextLayoutBlock_Entry = `
    fragment ds_RichTextLayoutBlock_Entry on ds_RichTextLayoutBlock_Entry {
        id
        canonicalUid

        richText_ColorTheme
        richText_ColorPalette
        richText_Text
        richText_ContentAlignment
        richText_Padding

        richText_ButtonAlignment
        richText_Buttons {
            target
            title
            text
            url
            ... on richText_Buttons_Url_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Url_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Custom_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Email_LinkType {
                buttonStyle
            }
            ... on richText_Buttons_Phone_LinkType {
                buttonStyle
            }
        }
    }
`
